<medpace-page>
    <div class="flex flex-col gap-medpace">
        <h1>Studies</h1>
        <medpace-studies></medpace-studies>
    </div>
</medpace-page>
